import _ from 'lodash';

import {
  LOAD_PLANTS_FAILURE,
  LOAD_PLANTS_SUCCESS,
  LOAD_PLANTS_UPDATE_AFTER_DELETE,
  UPDATE_PLANTS,
  UPDATE_PLANT_ITEM
} from './actions';

const initialState = {
  plants: []
};

function PlantsReducer(state = initialState, actions) {
  switch(actions.type) {
      case LOAD_PLANTS_SUCCESS: {
        const updatedPlants = _.get(actions, 'payload', []);
        const plants = updatedPlants.length ? updatedPlants : state.plants;
        return {
          ...state,
          plants,
        };
      }
      case LOAD_PLANTS_FAILURE: {
        return {
          ...state,
          error: actions.error
        };
      }
      case LOAD_PLANTS_UPDATE_AFTER_DELETE: {
        const updatedPlants = state.plants
          .filter(plant => plant.key !== actions.plantKeyId);
        return {
          ...state,
          plants: updatedPlants
        };
      }
      case UPDATE_PLANTS: {
        const plantToAdd = _.get(actions, 'plantToAdd', []);
        const plants = [...state.plants, ...plantToAdd];
        return {
          ...state,
          plants
        }
      }
      case UPDATE_PLANT_ITEM: {
        const plantToUpdate = _.get(actions, 'plant', {});
        const plants = state.plants.map((plant) => {
          if (plant.key === plantToUpdate.key) {
            return {
              ...plant,
              ...plantToUpdate,
            }
          } else {
            return plant;
          }
        });
        return {
          ...state,
          plants,
        }
      }
    default:
      return { ...state };
  }
}

export default PlantsReducer;
